import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import ProgramLandingPage from "./pages/ProgramLandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import FreeDemoPopup from "./components/landing/FreeDemoPopup";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <FreeDemoPopup />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/programs/:slug" element={<ProgramLandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
